import React from 'react';

export const IconLogo = () => (
  <img
    src="https://cdn.bfldr.com/YUHW9ZNT/at/pfbfh7-f4zem0-dpcdo2/brandfolder-icon"
    alt="Brandfolder logo"
  />
);
